<div>
  <form [formGroup]="countryWiseServiceRequirementListForm">
    <mat-card class="no_box_shadow">
      <mat-card-content>
        <div class="example-button-row" style="margin-top: 20px;">
          @if (addPermission) {
            <a class="__add_client" (click)="openForm()">
              <mat-icon class="__icon">add_circle</mat-icon>
              Create New
            </a>
          }
        </div>
        <mat-divider></mat-divider>
        @if (viewPermission) {
          <div class="table-scroll-container">
          <table mat-table matSort [dataSource]="dataSource" (matSortChange)="sortData($event)">
            <ng-container matColumnDef="countryName">
              <th mat-header-cell *matHeaderCellDef>
                <div class="sorting_header">
                  <span mat-sort-header>Country</span>
                  <input placeholder="Country..." type="search"
                    autocomplete="off" formControlName="countryName" class="mat-input-search">
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">{{ element.countryName }}</td>
              </ng-container>
              <ng-container matColumnDef="businessSegmentName">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="sorting_header">
                    <span mat-sort-header>Business Segment</span>
                    <input placeholder="Business Segment..." type="search"
                      autocomplete="off" formControlName="businessSegmentName" class="mat-input-search">
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.businessSegmentName }}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="cwsr-action-header">Action</th>
                  <td class="__action_row" mat-cell *matCellDef="let element">
                    @if (editPermission) {
                      <span class="__action_edit_icon" (click)="openForm(element.id)">
                        <mat-icon>create</mat-icon>
                      </span>
                    }
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columns"></tr>
                <tr mat-row *matRowDef="let row; columns: columns;"></tr>
              </table>
              </div>
            }
          </mat-card-content>
        </mat-card>
        @if (viewPermission) {
          <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="totalRecords" showFirstLastButtons></mat-paginator>
        }
      </form>
    </div>
